import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["loadingSpinner"];

  showLoadingSpinner() {
    this.loadingSpinnerTarget.classList.remove("loading-spinner-hidden");
    this.loadingSpinnerTarget.classList.add("loading-spinner-visible");
  }

  hideLoadingSpinner() {
    this.loadingSpinnerTarget.classList.remove("loading-spinner-visible");
    this.loadingSpinnerTarget.classList.add("loading-spinner-hidden");
  }

  async processInvoice(event) {
    event.preventDefault();
    const url = event.currentTarget.form.action;
    this.showLoadingSpinner();

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/vnd.turbo-stream.html",
        },
        credentials: "same-origin",
      });

      if (response.ok) {
        const turboStreamResponse = await response.text();
        Turbo.renderStreamMessage(turboStreamResponse);
      } else {
        console.log("error");
        // Get the error message from the response

        // Show an alert with the error message
        alert("error");
      }
    } catch (error) {
      console.log("catch error", error);
      // Handle the network error (e.g., show an error message)
      alert(`Network error: ${error.message}`);
    } finally {
      this.hideLoadingSpinner();
    }
  }
}
